export const container = (base, state) => {
    return { ...base, pointerEvents: state.isDisabled ? '' : '' };
};

export const control = (base, state, hasError) => {
    let borderStyle;

    if (hasError && !state.isDisabled) {
        borderStyle = '1px solid #d8000c'; // Error 100
    } else if (!state.isDisabled) {
        borderStyle = '1px solid #898b8e'; // Steel 75
    } else {
        borderStyle = '1px solid #ebecec'; // Concrete 25
    }

    return {
        ...base,
        backgroundColor: state.isDisabled ? null : null,
        border: borderStyle,
        borderRadius: state.selectProps.menuIsOpen ? '3px 3px 0 0' : 3,
        boxShadow: state.isFocused ? '0 0 4px 2px rgba(0, 119, 207 , 0.5)' : null, // Focused styling
        cursor: !state.isDisabled ? 'pointer' : 'not-allowed',
        minHeight: 38,
        zIndex: 1,

        ':hover': {
            border: !state.isDisabled ? '1px solid #898b8e' : '1px solid #ebecec' // Steel 75 : Concrete 25
        }
    };
};

export const placeholder = (base, state, insetLabel, hasInsetLabel) => {
    return {
        ...base,
        color: !state.isDisabled ? '#404040' : '#B0B1B3', // Black 75 : Steel 50
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        fontStyle: !state.isDisabled ? '' : 'italic',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        ':before': {
            // eslint-disable-next-line
            content: hasInsetLabel ? `'${insetLabel} '` : `''`
        }
    };
};

export const option = (base, state) => {
    let backgroundColorStyle;

    if (state.isSelected) {
        backgroundColorStyle = 'transparent';
    } else if (state.isFocused) {
        backgroundColorStyle = '#D8D9D9'; // Concrete 50
    } else {
        backgroundColorStyle = '';
    }

    return {
        ...base,
        backgroundColor: backgroundColorStyle,
        color: '#404040', // Black 75
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        height: 38,
        overflow: 'hidden',
        padding: state.isSelected ? '10px 42px 10px 10px' : 10,
        position: 'relative',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        zIndex: state.isFocused ? 2 : 1,

        ':hover': {
            backgroundColor: state.isSelected ? '#D8D9D9' : '#D8D9D9' // Concrete 50
        }
    };
};

export const valueContainer = (base, state) => {
    let paddingStyle;

    if (state.selectProps.isSearchable) {
        paddingStyle = '0px 8px 0px 36px';
    } else if (state.isMulti && state.hasValue) {
        paddingStyle = '4px';
    } else {
        paddingStyle = '4px 8px';
    }

    return {
        ...base,
        minHeight: '38px',
        padding: paddingStyle,

        input: {
            width: 0
        }
    };
};

export const singleValue = (base, state, insetLabel, hasInsetLabel) => {
    return {
        ...base,
        color: !state.isDisabled ? '#404040' : '#B0B1B3', // Black 75 : Steel 50
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        fontStyle: !state.isDisabled ? '' : 'italic',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',

        ':before': {
            // eslint-disable-next-line
            content: hasInsetLabel ? `'${insetLabel} '` : `''`
        }
    };
};

export const multiValue = (base, state) => {
    return {
        ...base,
        backgroundColor: '#f3f3f3', // Black 25
        border: !state.isDisabled ? '1px solid #B0B1B3' : '1px solid #D8D8D9', // Steel 50 : Concrete 50
        borderRadius: 5,
        margin: '2px 3px',

        ':hover': {
            backgroundColor: '#D8D9D9', // Concrete 50
            borderColor: '#D8D9D9' // Concrete 50
        }
    };
};

export const multiValueLabel = (base, state) => {
    return {
        ...base,
        color: !state.isDisabled ? '#626468' : '#B0B1B3', // Steel 100 : Steel 50
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        fontWeight: 600,
        paddingLeft: 8
    };
};

export const multiValueRemove = (base, state) => {
    let colorStyle;

    if (state.isFocused) {
        colorStyle = '#626468'; // Steel 100
    } else if (!state.isDisabled) {
        colorStyle = '#898B8E'; // Steel 75
    } else {
        colorStyle = '#B0B1B3'; // Steel 50
    }

    return {
        ...base,
        backgroundColor: 'transparent',
        borderRadius: 5,
        color: colorStyle,
        paddingLeft: 2,
        paddingRight: 8,
        pointerEvents: state.isDisabled ? 'none' : '',

        ':hover': {
            backgroundColor: 'transparent',
            color: '#898B8E' // Steel 75
        }
    };
};

export const menuList = base => {
    return {
        ...base,
        marginTop: 0,
        padding: 0
    };
};

export const menu = base => {
    return {
        ...base,
        borderColor: '#898b8e', // Steel 75
        borderRadius: '0 0 3px 3px',
        borderStyle: 'solid',
        borderWidth: '0 1px 1px 1px',
        marginTop: 0,
        maxHeight: 300,
        overflow: 'hidden',
        padding: 0,
        zIndex: 1
    };
};

export const dropdownIndicator = (base, state) => {
    let transformStyle;

    if (state.selectProps.isSearchable) {
        transformStyle = 'translateY(-50%)';
    } else if (state.selectProps.menuIsOpen && !state.selectProps.isSearchable) {
        transformStyle = 'rotate(180deg)';
    } else {
        transformStyle = null;
    }

    return {
        ...base,
        color: !state.isDisabled ? '#404040' : '#898b8e', // Black 75 : Concrete 50
        left: state.selectProps.isSearchable ? '16px' : null,
        padding: state.selectProps.isSearchable ? null : '8px',
        position: state.selectProps.isSearchable ? 'absolute' : null,
        top: state.selectProps.isSearchable ? '50%' : null,
        transform: transformStyle,
        transition: !state.selectProps.isSearchable ? 'transform ease .25s' : null
    };
};

export const noOptionsMessage = base => {
    return {
        ...base,
        fontFamily: 'Source Sans Pro',
        fontSize: 16,
        fontWeight: 600
    };
};

export const input = base => {
    return {
        ...base,
        paddingBottom: 6,
        paddingTop: 6
    };
};
